import React from 'react';
// import { connect } from 'react-redux';
// import { compose } from 'recompose';
import styled from 'styled-components';
import { colorGrid } from 's2s-themes';
import { HelpIconSVG } from 's2s-svg-icons';


const HelpContainer = styled.div`
  align-items : center;
  background-color: ${colorGrid.brand5};
  display : flex;
  //flex : 1; // NOTE : This is necessary in order to take up full container
  flex-direction : column;
  font-family : inherit;
  padding : 24px auto;
  height: 100vh;
  min-width: 320px;
  width: 100vw;
  color: ${colorGrid.gray0};
  justify-content: center;
`;

const HelpContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 8px;
`;

const HelpText = styled.div`
  margin-top: 16px;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 2px;
    line-height: 42px;
    text-align: center;
`;

const helpRoute = (/*props*/) => {
  // console.log('HELP ROUTE PROPS', props);
  return (
    <HelpContainer>
      <HelpContentContainer>
        <HelpIconSVG svgStyle={{
          fill: colorGrid.gray0,
          height: '192px',
          width: '192px'
        }} />
        <HelpText>
          The help screen will be included in a future release.
        </HelpText>
        <HelpText>
          For now, you can call our technical support department with your questions.
        </HelpText>
      </HelpContentContainer>
    </HelpContainer>
  );
};

helpRoute.propTypes = {

};



export default helpRoute;